const ClipboardCopy = ({ value, children, tooltip = value }) => {

    const copy = () => {
        const selBox = document.createElement('textarea');
        selBox.style.position = 'fixed';
        selBox.style.left = '0';
        selBox.style.top = '0';
        selBox.style.opacity = '0';
        selBox.value = value;
        document.body.appendChild(selBox);
        selBox.focus();
        selBox.select();
        document.execCommand('copy');
        document.body.removeChild(selBox);
    }

    return (
        <span onClick={copy} data-tooltip={tooltip} className="is-clickable">
            {children}
        </span>
    )
};

export { ClipboardCopy };
